var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"font-bold uppercase bg-brand-green hover:bg-brand-green-dark",attrs:{"href":_vm.href}},[_vm._v("\n    "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"ml-4 fa-lg fas fa-angle-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }